import {
  base_colorActionHover,
  base_colorContentBorder,
  base_colorRaisedSurface,
  base_colorSurfaceSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import styled, { css } from 'styled-components'

export default css`
  /* TODO: Standardize z-index */
  z-index: 10;
  &.small {
    --border-radius: ${spacing(1)};
  }
  &.medium {
    --border-radius: ${spacing(2)};
  }

  &[data-popper-reference-hidden] {
    visibility: hidden;
    pointer-events: none;
  }

  .menu {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin: ${spacing(2)} 0;
    list-style: none;
    background-color: ${base_colorRaisedSurface};
    border: 1px solid ${base_colorActionHover};
    border-radius: var(--border-radius);
  }

  .search-container {
    display: flex;
    gap: ${spacing(2)};
    align-items: center;
    border-radius: var(--border-radius) var(--border-radius) 0 0;
    background: ${base_colorSurfaceSecondary};
    border-bottom: 1px solid ${base_colorContentBorder};
    &.small {
      padding: ${spacing(2)} ${spacing(3)};
    }
    &.medium {
      padding: ${spacing(2)} ${spacing(5)};
    }

    &.hidden {
      height: 0;
      padding: 0;
      opacity: 0;
    }

    & .search-icon {
      &.small {
        min-width: ${spacing(4)};
        min-height: ${spacing(4)};
      }
      &.medium {
        min-width: ${spacing(6)};
        min-height: ${spacing(6)};
      }
    }
  }

  .scroll-container {
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
  }

  /*
   * Persistent action row pinned below the option list, outside
   * .scroll-container — the design system's "Overlay Actions" footer: top
   * border, secondary-surface tint, single right-aligned CTA.
   *
   * One selector for both: the Reset row and the caller-supplied footer are the
   * same treatment — the Reset row is that pattern hard-wired to one button.
   * Shared rather than two identical copies, which would drift.
   */
  .dropdown-menu-footer,
  .reset-container {
    border-radius: 0 0 var(--border-radius) var(--border-radius);
    background: ${base_colorSurfaceSecondary};
    padding: ${spacing(2)};
    border-top: 1px solid ${base_colorContentBorder};

    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .reset-button {
    padding: ${spacing(2)};
  }
`

// in order to dynamically set width, we need to be able to pass props in
export const StyledListbox = styled.div<{
  width?: number
  dropdownOptionsCount: number
}>`
  width: ${({ width }) => (width ? `${width}px` : `100%`)};
  min-width: 300px;
  // allows for dropdownOptionCount items + overflow so scrolling is obvious.
  // --dropdown-available-height is set by the Popper viewport modifier when the
  // menu opens low on the page; min() caps the menu to whichever is smaller so
  // it stays on-screen and scrolls instead of spilling past the viewport.
  max-height: ${({ dropdownOptionsCount }) =>
    `min(calc(${spacing(13)} * (${dropdownOptionsCount} + 0.6)), var(--dropdown-available-height, 100vh))`};
`

// popper container is rendered separately in the DOM hierarchy, so it needs its own styles
export const popperStyles = css``
